import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { areas } from '../../constants/areas';
import Portal from '../../utils/portal/Portal';
import { withAreaGetter } from '../../providers/AreasConsumers';
import { getInt } from 'utils/functions';
import ReportHeader from './ReportHeader';
import ReportCardContainer from './ReportCardContainer';

class ReportRoute extends React.PureComponent {
  constructor(props) {
    super(props);
    this.reportId = getInt(props.match.params.reportId);
  }

  state = {
    reportName: ''
  };

  onCloseClick = () => {
    this.props.history.push('/reports');
  };

  pushReportName = reportName => {
    this.setState({ reportName });
  };

  render() {
    const { reportName } = this.state;
    const { reportId, pushReportName, onCloseClick } = this;

    return (
      <>
        <ReportCardContainer reportId={reportId} pushReportName={pushReportName} />
        <Portal container={this.props.getElemByAreaKey(areas.header)}>
          <ReportHeader onCloseClick={onCloseClick} reportName={reportName} />
        </Portal>
      </>
    );
  }
}

ReportRoute.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getElemByAreaKey: PropTypes.func.isRequired
};

export default compose(withRouter, withAreaGetter, withTranslation())(ReportRoute);
